import { useLocation, useNavigate } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import { v2ModuleLabel } from "../context/V2Context";

export default function ComingSoon({ label: labelProp }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const label = labelProp || v2ModuleLabel(pathname);
  return (
    <div className="flex min-h-[70vh] items-center justify-center" data-testid="v2-coming-soon">
      <div className="relative max-w-xl w-full rounded-3xl bg-[#3E2723] text-white px-10 py-14 text-center overflow-hidden shadow-[0_24px_60px_-18px_rgba(62,39,35,0.5)]">
        <div className="pointer-events-none absolute -top-16 -right-16 h-48 w-48 rounded-full bg-[#8D6E63]/30 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-[#FFB300]/10 blur-3xl" />
        <span className="inline-flex items-center gap-1.5 rounded-full bg-[#FFB300] px-4 py-1.5 text-xs font-bold text-[#3E2723]" data-testid="v2-badge">
          <Sparkles size={13} /> COCOA VERSION 2
        </span>
        <h1 className="font-heading mt-6 text-3xl sm:text-4xl font-bold" data-testid="v2-module-name">{label}</h1>
        <p className="mt-4 text-sm text-white/70 leading-relaxed">
          This module is part of <span className="font-semibold text-white">COCOA Version 2</span> and is
          being polished behind the curtains. It will be activated for your clinic very soon.
        </p>
        <button data-testid="v2-back-dashboard-btn" onClick={() => navigate("/")}
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-white/10 px-5 py-2.5 text-sm font-semibold hover:bg-white/20 transition-colors">
          <ArrowLeft size={15} /> Back to Dashboard
        </button>
      </div>
    </div>
  );
}
